import React from 'react'
import styled from 'styled-components'
import { AutoRow } from '../../../components/Row'

const IconLoading = styled.div`
  position: relative;
  top: 50%;
  left: 50%;
  display: inline-block;
  zoom: 0.2;
  @-webkit-keyframes loading {
    from {opacity: 1;width:5px;height:20px;}
    to {opacity: 0.25;width:5px;height:20px;}
  }
  @keyframes loading {
    from {opacity: 1;width:5px;height:20px;}
    to {opacity: 0.25;width:5px;height:20px;}
  }
  & > div {
    width:3px;
    height:16px;
    background: ${({theme}) => theme.bsBg4};
    position: absolute;
    left: 100%;
    top: 100%;
    margin-top: -30px;
    opacity: 0;
    -webkit-animation: loading 1.2s linear infinite;
  }
  .line1 {-webkit-transform:rotate(0deg) translate(0, -34px); -webkit-animation-delay: 0s;}
  .line2 {-webkit-transform:rotate(30deg) translate(0, -34px); -webkit-animation-delay: 0.1s;}
  .line3 {-webkit-transform:rotate(60deg) translate(0, -34px); -webkit-animation-delay: 0.2s;}
  .line4 {-webkit-transform:rotate(90deg) translate(0, -34px); -webkit-animation-delay: 0.3s;}
  .line5 {-webkit-transform:rotate(120deg) translate(0, -34px); -webkit-animation-delay: 0.4s;}
  .line6 {-webkit-transform:rotate(150deg) translate(0, -34px); -webkit-animation-delay: 0.5s;}
  .line7 {-webkit-transform:rotate(180deg) translate(0, -34px); -webkit-animation-delay: 0.6s;}
  .line8 {-webkit-transform:rotate(210deg) translate(0, -34px); -webkit-animation-delay: 0.7s;}
  .line9 {-webkit-transform:rotate(240deg) translate(0, -34px); -webkit-animation-delay: 0.8s;}
  .line10 {-webkit-transform:rotate(270deg) translate(0, -34px); -webkit-animation-delay: 0.9s;}
  .line11 {-webkit-transform:rotate(300deg) translate(0, -34px); -webkit-animation-delay: 1.0s;}
  .line12 {-webkit-transform:rotate(330deg) translate(0, -34px); -webkit-animation-delay: 1.1s;}
`

const LoadingLabel = styled.div`
  margin-left: 20px;
  color: ${({theme}) => theme.bsBg11};
  font-weight: 600;
`

interface TopStakeLoading {
  loadingState: Boolean
}

const Loading: React.FC<TopStakeLoading> = ({ loadingState }) => {
  return (
    <AutoRow justify="center" style={{paddingBottom: '10px', marginTop: '10px', visibility: loadingState ? 'visible' : 'hidden'}}>
      <div>
        <IconLoading>
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
          <div className="line4"></div>
          <div className="line5"></div>
          <div className="line6"></div>
          <div className="line7"></div>
          <div className="line8"></div>
          <div className="line9"></div>
          <div className="line10"></div>
          <div className="line11"></div>
          <div className="line12"></div>
        </IconLoading>
      </div>
      <LoadingLabel>loading</LoadingLabel>
    </AutoRow>
  )
}
export default Loading